import { ClaimStage } from '@/types/claims'
import { FileText, ClipboardList, Eye, Users, Settings, FileCheck, CheckCircle2, Rocket } from 'lucide-react'

export const STAGE_ORDER: ClaimStage[] = [
  'preliminar',
  'vistoria',
  'documentacao',
  'distribuicao',
  'super_fast_track', // 🚀 Super Fast Track como estágio entre distribuição e regulação
  'regulacao',
  'revisao',
  'concluido'
]

// 🚀 Stages simplificados para Super Fast Track (fluxo prioritário com apenas 2 estágios)
export const SUPER_FAST_TRACK_STAGES: ClaimStage[] = [
  'super_fast_track',
  'revisao',
  'concluido'
]

export const STAGE_COLORS = {
  preliminar: {
    bg: 'bg-blue-50/80 dark:bg-blue-950/50',
    text: 'text-blue-800 dark:text-blue-200',
    title: 'Preliminar',
    link: 'text-blue-700 dark:text-blue-300',
    count: 'bg-blue-100/80 dark:bg-blue-900/80',
    button: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    border: 'border-blue-500 dark:border-blue-400'
  },
  vistoria: {
    bg: 'bg-violet-50/80 dark:bg-violet-950/50',
    text: 'text-violet-900 dark:text-violet-200',
    title: 'Vistoria',
    link: 'text-violet-800 dark:text-violet-300',
    count: 'bg-violet-100/80 dark:bg-violet-900/80',
    button: 'bg-violet-100 text-violet-900 dark:bg-violet-900 dark:text-violet-200',
    border: 'border-violet-500 dark:border-violet-400'
  },
  documentacao: {
    bg: 'bg-purple-50/80 dark:bg-purple-950/50',
    text: 'text-purple-900 dark:text-purple-200',
    title: 'Documentação',
    link: 'text-purple-800 dark:text-purple-300',
    count: 'bg-purple-100/80 dark:bg-purple-900/80',
    button: 'bg-purple-100 text-purple-900 dark:bg-purple-900 dark:text-purple-200',
    border: 'border-purple-500 dark:border-purple-400'
  },
  distribuicao: {
    bg: 'bg-cyan-50/80 dark:bg-cyan-950/50',
    text: 'text-cyan-900 dark:text-cyan-200',
    title: 'Distribuição',
    link: 'text-cyan-800 dark:text-cyan-300',
    count: 'bg-cyan-100/80 dark:bg-cyan-900/80',
    button: 'bg-cyan-100 text-cyan-900 dark:bg-cyan-900 dark:text-cyan-200',
    border: 'border-cyan-500 dark:border-cyan-400'
  },
  regulacao: {
    bg: 'bg-teal-50/80 dark:bg-teal-950/50',
    text: 'text-teal-900 dark:text-teal-200',
    title: 'Regulação',
    link: 'text-teal-800 dark:text-teal-300',
    count: 'bg-teal-100/80 dark:bg-teal-900/80',
    button: 'bg-teal-100 text-teal-900 dark:bg-teal-900 dark:text-teal-200',
    border: 'border-teal-500 dark:border-teal-400'
  },
  revisao: {
    bg: 'bg-emerald-50/80 dark:bg-emerald-950/50',
    text: 'text-emerald-800 dark:text-emerald-200',
    title: 'Revisão',
    link: 'text-emerald-700 dark:text-emerald-300',
    count: 'bg-emerald-100/80 dark:bg-emerald-900/80',
    button: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200',
    border: 'border-emerald-500 dark:border-emerald-400'
  },
  super_fast_track: {
    bg: 'bg-orange-50/80 dark:bg-orange-950/50',
    text: 'text-orange-900 dark:text-orange-200',
    title: 'Super Fast Track',
    link: 'text-orange-800 dark:text-orange-300',
    count: 'bg-orange-100/80 dark:bg-orange-900/80',
    button: 'bg-orange-100 text-orange-900 dark:bg-orange-900 dark:text-orange-200',
    border: 'border-orange-500 dark:border-orange-400'
  },
  concluido: {
    bg: 'bg-emerald-50/80 dark:bg-emerald-950/50',
    text: 'text-emerald-800 dark:text-emerald-200',
    title: 'Concluído',
    link: 'text-emerald-700 dark:text-emerald-300',
    count: 'bg-emerald-100/80 dark:bg-emerald-900/80',
    button: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200',
    border: 'border-emerald-500 dark:border-emerald-400'
  }
} as const

export const STAGE_ICONS = {
  preliminar: FileText,
  documentacao: ClipboardList,
  vistoria: Eye,
  distribuicao: Users,
  regulacao: Settings,
  revisao: FileCheck,
  super_fast_track: Rocket,
  concluido: CheckCircle2
} as const

export type StageColors = typeof STAGE_COLORS

export const PRODUCT_TYPES = ['auto', 'residencial', 'empresarial', 'saude']